import type { FaireProductEntity } from "../../entity_types/product";

export const p_sp458mswhv: FaireProductEntity = {
  token: "p_sp458mswhv",
  type: "product",
  name: "Rice Water Shampoo Bar for Hair Growth",
  brandToken: "b_dljmfs9o",
  brandName: "KITSCH",
  imageUrl:
    "https://cdn.faire.com/fastly/f7dce4918607477783c24f72bc0711a794cba1ae4b13e894f3c81488e2fe7b10.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27376b081cd8890fd994acdd661e19e41c20748c4262aa796eadbecff2c1a6ce.jpeg",
    "https://cdn.faire.com/fastly/fc655619381a67a5fc334e954646cae60e982c207b091318c57d809949873814.jpeg",
    "https://cdn.faire.com/fastly/075149834a7075c19b3be03de38de69ca3a271a54c980357dc3c7584a2905743.jpeg",
  ],
  priceDollars: 9.7,
  description:
    "-Formulated with rice water to repair damaged hair follicles & prevent split ends\n-Rice Protein has been shown to increase hair volume by 20% after 5 washes*\n\nWhy You'll Love This:\n-Gives you a nourishing cleanse to encourage overall hair length & density \n-Boosts shine in dull, dry hair\n-Free of parabens, phthalates, silicones, sulfates, & artificial fragrance\n-PH balanced and safe for color-treated hair\n-Reduces single-use plastic: saves two bottles of liquid shampoo/conditioner.\n-Made in the USA, Vegan, Cruelty Free, Leaping Bunny Certified\n*based on TRI-K Rice Tein NPNF study after 5 washes\n\n4OCEAN CERTIFIED: For every shampoo or conditioner bar, 4ocean pulls the equivalent of one shampoo bottle’s worth of plastic from the world's oceans, rivers, and coastlines",
  tags: [],
  msrpDollars: 19.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:45.356Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
